import { Box } from "@mui/material";
import { Alert, AlertTitle } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

export const UnauthorizedPage = () => {
  const { formatMessage: t } = useIntl();
  return (
    <Box>
      <Alert severity="error">
        <AlertTitle>
          <strong>{t({ id: "unauthorizedLabel" })}</strong>
        </AlertTitle>
        {t({ id: "unauthorizedMessage" })}
      </Alert>
    </Box>
  );
};
